<template lang="html">
  <v-page class="client sign" :profile="profile">
    <v-topbar :profile="profile" />

    <v-breadcrumb
      v-if="profile === 'client'"
      :steps="[
        { label: 'Profissionais', to: { name: 'client-vibbrants' } },
        {
          label: contract.vibbrante.name,
          to: { name: 'client-vibbrants-pending' },
        },
        { label: 'Contrato' },
      ]"
    />
    <v-breadcrumb
      v-else
      :steps="[
        { label: 'Clientes', to: { name: 'vibbrant-clients' } },
        {
          label: contract.client.name,
          to: { name: 'vibbrant-clients-pending' },
        },
        { label: 'Contrato' },
      ]"
    />

    <v-vibbrante-contract
      v-if="contract.contract_type === 'vibbrante'"
      :profile="profile"
    />
    <v-freelancer-contract
      v-if="contract.contract_type === 'freelancer'"
      :profile="profile"
    />
  </v-page>
</template>

<script>
import VibbranteContract from '@/parts/components/vibbrante-contract';
import FreelancerContract from '@/parts/components/freelancer-contract';
import apiVibbrante from '@/api/vibbrante';
import apiClient from '@/api/client';

export default {
  props: {
    profile: String,
    contract: {},
    vibbrante: {},
    client: {},
  },
  components: {
    'v-vibbrante-contract': VibbranteContract,
    'v-freelancer-contract': FreelancerContract,
  },
  data() {
    return {
      is_pf: false,
      terms_check: false,
      hour_val: 60,
      hour_discount: 0,
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      if (this.profile === 'vibbrant') {
        apiVibbrante
          .vibbranteGetContract(this.$route.params.id)
          .then(response => {
            if (response.status === 200) {
              this.contract = response.data;
              this.$store.dispatch(
                'loadVibbranteCurrentContract',
                response.data
              );
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
        apiVibbrante
          .getVibbranteData()
          .then(response => {
            if (response.status === 200) {
              this.vibbrante = response.data;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        apiClient
          .clientGetContract(this.$route.params.id)
          .then(response => {
            if (response.status === 200) {
              this.contract = response.data;
              this.$store.dispatch('loadClientCurrentContract', response.data);
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
        apiClient
          .getClientData()
          .then(response => {
            if (response.status === 200) {
              this.client = response.data;
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
    signContract() {
      if (this.profile === 'vibbrant') {
        // this.contract.expected_start_date = this.$moment(this.contract.expected_start_date, 'DD/MM/YYYY').format('YYYY-MM-DD')

        apiVibbrante
          .vibbranteAcceptContract(this.contract)
          .then(response => {
            if (response.status === 200) {
              apiVibbrante
                .loadPendingContracts()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadVibbranteWaitingAnswerContracts',
                      response.data
                    );
                    this.$router.push({ name: 'vibbrant-clients-pending' });
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });

              apiVibbrante
                .loadActivesContracts()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadVibbranteActivesContracts',
                      response.data
                    );
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      } else {
        let pj_or_pf = 'PJ';
        if (this.is_pf) {
          pj_or_pf = 'PF';
        }
        apiClient
          .clientActivedContract(this.contract.id, pj_or_pf)
          .then(response => {
            if (response.status === 200) {
              apiClient
                .loadPendingContracts()
                .then(response => {
                  if (response.status === 200) {
                    this.$store.dispatch(
                      'loadClientWaitingAnswerContracts',
                      response.data
                    );
                    this.$router.push({ name: 'client-vibbrants-pending' });
                  }
                })
                .catch(e => {
                  this.$notify(e, 'error');
                });
            }
          })
          .catch(e => {
            this.$notify(e, 'error');
          });
      }
    },
  },
  computed: {
    fullName() {
      return this.contract.client.name + ' ' + this.contract.client.lastname;
    },
    fullAddress() {
      return (
        this.contract.client.address + ' ' + this.contract.client.address_number
      );
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/parts/pages/sign.vue